import gsap from "gsap"

export default function preloader(){
   return gsap.to('#preloader', {
        delay: 0, 
        opacity:0, 
        onComplete: function(){
          const preloader = document.querySelector('#preloader')
          preloader.style.display = 'none'
        }
      })
}